import React from 'react';
import { createIcon } from './createIcon.es.js';

/* eslint react/display-name: 0 */
var DropdownArrowIcon = createIcon({
  name: 'DropdownArrowIcon',
  width: 64,
  height: 64,
  render: function render(_ref) {
    var width = _ref.width,
        height = _ref.height;
    return /*#__PURE__*/React.createElement("svg", {
      "aria-hidden": "true",
      viewBox: "0 0 24 24",
      width: width,
      height: height
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      d: "M6.7 9.3l5.3 5.4 5.3-5.4"
    }));
  }
});

export { DropdownArrowIcon };
